import { $elementChild, $element } from "@grindex-common/helpers/elements";
import { addListener } from "@grindex-common/helpers/domManipulation";

const MOBILE_SHARE_CONTAINER = "mobile-share-container";
const SHARE_WINDOW_DIMENSIONS = "width=800,height=600";
const SHARE_WINDOW = "share-dialog";
const CLASS_ACTIVE = "active";

function init($views) {
	$views.forEach(($view) => {
		const $mobileShare = $element(MOBILE_SHARE_CONTAINER);
		const $deskTopShareTriggers = $view.querySelectorAll(".share-links a");
		const $mobileShareTrigger = $elementChild($view, "mobile-share-trigger");

		addListener($deskTopShareTriggers, "click", activateShareLink);
		addListener($mobileShareTrigger, "click", toggleMobileShare);

		function activateShareLink(e) {
			e.preventDefault();
			window.open(e.currentTarget.href, SHARE_WINDOW, SHARE_WINDOW_DIMENSIONS);

			return false;
		}

		function toggleMobileShare() {
			$mobileShare.classList.toggle(CLASS_ACTIVE);
		}
	});
}

export default {
	view: "share",
	init,
};
